<template>
  <div class="col-grow flex justify-between h-full bg-white">
    <window-search @selected="selected" :fetch-data="fetchData" :columns="columns">
    </window-search>
  </div>
</template>

<script>
import {WindowSearch} from 'uloc-vue-plugin-erp'

export default {
  components: {WindowSearch},
  props: {
    columns: Array,
    fetchData: Function
  },
  data () {
    return {
      window: this.$root.wid
    }
  },
  methods: {
    selected (val) {
      this.$uloc.window.emit(this.window, 'selected', val)
      this.$uloc.window.close(this.window)
    }
  }
}
</script>
